
//const PusherKey = '09afdc6a85ab06e96547';

const PusherKey =process.env.REACT_APP_PUSHERKEY;
export default PusherKey;
export const PUSHERENV=process.env.REACT_APP_PUSHERENV;
